import { reportErrorToSlack } from "@onesolution/utils/reportToSlack";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import {
	type PersistQueryClientOptions,
	persistQueryClient,
} from "@tanstack/react-query-persist-client";

const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error, query) => {
			reportErrorToSlack("QUERY ERROR", { query }, error);
		},
	}),
	mutationCache: new MutationCache({
		onError: (error, variables, context, mutation) => {
			reportErrorToSlack(
				"MUTATION ERROR",
				{ variables, context, mutation },
				error,
			);
		},
	}),
	defaultOptions: {
		queries: {
			gcTime: 5 * 60 * 1000, // 5 minutes
			refetchOnMount: true,
		},
	},
});

if (typeof window !== "undefined") {
	const localStoragePersister = createAsyncStoragePersister({
		storage: window.localStorage,
	});

	persistQueryClient({
		queryClient:
			queryClient as unknown as PersistQueryClientOptions["queryClient"],
		persister: localStoragePersister,
	});
}

export default queryClient;
